import styles from "@/asserts/styles/formSection.module.less";
import { MaterialFileFormFields } from "@/components/commonFormItems/MaterialFileFormFields";
import ModalSectionHeader from "@/components/ui/ModalSectionHeader";
import { Col, Form, Input, Row } from "antd";
import type { RldReferenceProductRequisitionFormValue } from "../../type";
import { useFormEditable } from "../../hooks/useFormEditable";
import { useTranslation } from "react-i18next";

export const SpecialRequirementFormFields = () => {
  const { t } = useTranslation("purchaseRequestManagement");
  const { isMainFormDisabled } = useFormEditable();
  return (
    <div className={styles.formSection}>
      <ModalSectionHeader title={t("特别要求")} />

      <div className={styles.sectionBody}>
        <Row gutter={49}>
          <Col span={24}>
            <Form.Item<RldReferenceProductRequisitionFormValue>
              name="batchRequirements"
              label={t("批次要求")}
              rules={[
                {
                  required: true,
                  message: t("请输入"),
                },
              ]}
            >
              <Input.TextArea rows={2} placeholder={t("请输入")} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item<RldReferenceProductRequisitionFormValue>
              name="expiryRequirements"
              label={t("效期要求")}
              rules={[
                {
                  required: true,
                  message: t("请输入"),
                },
              ]}
            >
              <Input.TextArea rows={2} placeholder={t("请输入")} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item<RldReferenceProductRequisitionFormValue>
              name="requirementsRemarks"
              label={t("备注说明")}
            >
              <Input.TextArea rows={2} placeholder={t("请输入")} />
            </Form.Item>
          </Col>
        </Row>

        <MaterialFileFormFields
          fieldName="requirementsFiles"
          label={t("其他附件")}
          required={false}
          hiddenRemove={isMainFormDisabled}
        />
      </div>
    </div>
  );
};
